<template>
  <div v-if="hasHeaderImage" class="mt-4 mb-4 mx-4 md:mx-2">
    <div class="rounded-none md:rounded-lg overflow-hidden">
      <img
        :src="headerImageURL"
        :alt="storeName"
        class="w-auto h-32 sm:h-56 md:h-72 shadow-solid-xs shadow-gray-brand-200 object-cover w-full h-full"
      />
    </div>
  </div>
  <slot />
  <div
    v-if="bannerDescription"
    class="mx-4 md:mx-2 px-2 py-3 rounded-lg bg-gray-brand-100 text-gray-brand-800 whitespace-pre-wrap"
  >
    {{ bannerDescription }}
  </div>
</template>

<script>
export default {
  name: 'V2StoreHeader',

  props: {
    storeName: {
      type: String,
      default: ''
    },
    attachments: {
      type: Array,
      default: () => []
    },
    bannerDescription: {
      type: String,
      default: ''
    }
  },

  computed: {
    hasHeaderImage() {
      return this.attachments.length > 0
    },
    headerImageURL() {
      // BOT-972: prefer the high-res variant for the wide store banner;
      // fall back to the standard `url` (Cloudinary 552x552 capped) so a
      // non-image attachment or older snapshot without high_res_url still
      // renders. Mirrors V1 MerchantMain.headerImageURL.
      return this.attachments[0]?.high_res_url || this.attachments[0]?.url
    }
  }
}
</script>
